<template>
  <div></div>
</template>

<script>
  import { loginXSKSystem } from '@/config/api';

  export default {
    name: 'StudentCard',
    data() {
      return {
        url: '',
      };
    },
    created() {
      loginXSKSystem().then((res) => {
        if (res.data.resCode == 200) {
          window.open(res.data.data);
        }
      });
    },
  };
</script>

<style scoped>
  .ele-admin-iframe {
    width: 100%;
    height: calc(100vh - 60px);
    box-sizing: border-box;
    display: block;
    border: none;
  }
</style>
